"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numbersOverlap = void 0;
function numbersOverlap(arr) {
    for (let i = 0; i < arr.length; i++) {
        const current = arr[i];
        const hasOverlap = arr.some((item, idx) => {
            const isTheSameAsCurrentItem = idx === i;
            if (isTheSameAsCurrentItem)
                return false;
            return current.start <= item.end && current.end >= item.end;
        });
        if (hasOverlap)
            return true;
    }
    return false;
}
exports.numbersOverlap = numbersOverlap;
